import Vue from "vue";
import "vant/lib/index.css";
import {
  Area,
  Button,
  Card,
  Cell,
  CellGroup,
  CheckboxGroup,
  Checkbox,
  Col,
  DatetimePicker,
  Dialog,
  Divider,
  Popup,
  PullRefresh,
  Panel,
  Picker,
  Toast,
  Tab,
  TabbarItem,
  Tabs,
  Tag,
  Tabbar,
  List,
  Icon,
  ImagePreview,
  Image,
  Field,
  Swipe,
  SwipeItem,
  SwitchCell,
  Stepper,
  Grid,
  GridItem,
  RadioGroup,
  Radio,
  Row,
  NavBar,
  Notify,
  Overlay,
  Form,
  Empty,
  Uploader,
  SubmitBar,
  NoticeBar,
  Lazyload,
  Loading,
  ActionSheet,
  AddressEdit,
  AddressList,
  CouponCell,
  CouponList,
  Skeleton,
  PasswordInput,
  NumberKeyboard
} from "vant";
Vue.use(Skeleton);
Vue.use(CouponCell);
Vue.use(CouponList);
Vue.use(Lazyload);
Vue.use(ActionSheet);
Vue.use(Dialog);
Vue.component(AddressList.name, AddressList);
Vue.component(AddressEdit.name, AddressEdit);
Vue.component(NoticeBar.name, NoticeBar);
Vue.component(SubmitBar.name, SubmitBar);
Vue.component(Uploader.name, Uploader);
Vue.component(Empty.name, Empty);
Vue.component(Form.name, Form);
Vue.component(Overlay.name, Overlay);
Vue.component(Image.name, Image);
Vue.component(Button.name, Button);
Vue.component(Card.name, Card);
Vue.component(Cell.name, Cell);
Vue.component(Divider.name, Divider);
Vue.component(Tag.name, Tag);
Vue.component(Grid.name, Grid);
Vue.component(GridItem.name, GridItem);
Vue.component(Checkbox.name, Checkbox);
Vue.component(Area.name, Area);
Vue.component(Button.name, Button);
Vue.component(Field.name, Field);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Tabs.name, Tabs);
Vue.component(Tab.name, Tab);
Vue.component(Tabbar.name, Tabbar);
Vue.component(TabbarItem.name, TabbarItem);
Vue.component(Icon.name, Icon);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(Radio.name, Radio);
Vue.component(Tabbar.name, Tabbar);
Vue.component(TabbarItem.name, TabbarItem);
Vue.component(Toast.name, Toast);
Vue.component(Tabs.name, Tabs);
Vue.component(Notify.name, Notify);
Vue.component(NavBar.name, NavBar);
Vue.component(Popup.name, Popup);
Vue.component(Icon.name, Icon);
Vue.component(Loading.name, Loading);
Vue.component(Tab.name, Tab);
Vue.component(CellGroup.name, CellGroup);
Vue.component(Area.name, Area);
Vue.component(List.name, List);
Vue.component(PullRefresh.name, PullRefresh);
Vue.component(Dialog.name, Dialog);
Vue.component(Field.name, Field);
Vue.component(Picker.name, Picker);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(ImagePreview.name, ImagePreview);
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Panel.name, Panel);
Vue.component(Row.name, Row);
Vue.component(Col.name, Col);
Vue.component(SwitchCell.name, SwitchCell);
Vue.component(Stepper.name, Stepper);
Vue.component(PasswordInput.name, PasswordInput);
Vue.component(NumberKeyboard.name, NumberKeyboard);
